import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { ordersLoader } from './orders-loader';

export const ordersRoutes: RouteObject = {
  loader: ordersLoader,
  children: [
    {
      path: '/admin/coupon-orders',
      lazy: lazyComponent(() => import('@pages/tenant/order-coupon'), 'CouponOrdersPage'),
    },
    {
      path: '/admin/coupon-orders/create',
      lazy: lazyComponent(
        () => import('@pages/tenant/order-coupon'),
        'CouponOrderCreatePage',
      ),
    },
    {
      path: '/admin/fuel-orders',
      lazy: lazyComponent(() => import('@pages/tenant/order-fuel'), 'FuelOrdersPage'),
    },
  ],
};
